import TomSelect from "tom-select";

// Поле выбора пользователя с поиском по части email. В форму приходит только текущее
// значение, остальные варианты виджет берёт с сервера порциями: dropdown_input выносит
// поле ввода отдельной строкой над списком, virtual_scroll догружает следующую порцию
// при прокрутке.
export const UserSelect = () => {
	$(document).ready(() => {
		document.querySelectorAll("select[data-search-url]").forEach(setupUserSelect);
	});
};

const pageUrl = (searchUrl, query, page) =>
	`${searchUrl}?term=${encodeURIComponent(query)}&page=${page}`;

const setupUserSelect = (select) => {
	const searchUrl = select.dataset.searchUrl;

	new TomSelect(select, {
		valueField: "id",
		labelField: "text",
		searchField: "text",
		maxOptions: null,
		// без предзагрузки список пуст, пока не начнёшь печатать (shouldLoad не пускает
		// пустой запрос); preload: 'focus' в паре с dropdown_input не срабатывает —
		// плагин переводит фокус на сам контрол, а не на поле ввода
		preload: true,
		plugins: ["dropdown_input", "virtual_scroll"],
		// дефолтные сообщения tom-select и плагина virtual_scroll — англоязычные
		render: {
			no_results: () => '<div class="no-results">Ничего не найдено</div>',
			loading_more: () => '<div class="loading-more-results">Загружаем ещё…</div>',
			no_more_results: () => '<div class="no-more-results">Это все совпадения</div>',
		},
		firstUrl: (query) => pageUrl(searchUrl, query, 0),
		load: function (query, callback) {
			fetch(this.getUrl(query), { headers: { Accept: "application/json" } })
				.then((response) => response.json())
				.then(({ results, more, page }) => {
					if (more) this.setNextUrl(query, pageUrl(searchUrl, query, page + 1));
					callback(results);
				})
				.catch(() => callback());
		},
	});
};
